import { render } from "./QuoteIcon.vue?vue&type=template&id=161e1f5a"
import script from "./QuoteIcon.vue?vue&type=script&lang=js"
export * from "./QuoteIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/santoshmaharjan/Documents/htdocs/helmetsnepal-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__